import React, {useEffect, useRef, useState} from "react";
import moment from "moment";
import "moment/locale/fr";

import './FormulaireAncv.scss';
import CustomSlider from "../fields/CustomSlider";
import {AncvService} from "../../../service/AncvService";
import {ClapService} from "../../../service/ClapService";
import {useSelector} from "react-redux";
import {Accordion, AccordionTab} from "primereact/accordion";
import {FieldBuilder} from "../fields/FieldBuilder";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {ChequeCultureService} from "../../../service/ChequeCultureService";
import {LinkProviderService} from "../../../service/LinkProviderService";
import {FileService} from "../../../service/FileService";
import {ParamModuleService} from "../../../service/ParamModuleService";
import {Dropdown} from "primereact/dropdown";
import LoaderDots from '../fields/LoaderDots';
import { resetRetry,canRetry } from '../../utils/RetryManager'

export const FormulaireAncv = ({mode, hiddenNoticeButton, onConfirm, oldForm}) => {

    const codeCasAncv = "3031";
    const user = useSelector((state) => state.usager.user);
    const actionSociale = useSelector((state) => state.actionSociale);

    const [currentActionSociale, setCurrentActionSociale] = useState({});
    const [baremes, setBaremes] = useState([]);
    const [refBancaires, setRefBancaires] = useState({});

    const valParticipationPourcentage= useSelector((state) => state.actionSociale.maxVal);
    const [valParticipation, setValParticipation] = useState(0);
    const [valMaxParticipation, setValMaxParticipation] = useState(0);

    const [participationMaxCgos, setParticipationMaxCgos] = useState(0);
    const [participationMinCgos, setParticipationMinCgos] = useState(0);

    const [isParamModuleOk, setIsParamModuleOk] = useState(false);

    const [isStep1Completed, setIsStep1Completed] = useState(false);
    const [ancvType, setAncvType] = useState(null);

    const [isStep2Completed, setIsStep2Completed] = useState(false);
    const [paiementType, setPaiementType] = useState(null);

    const [isStep3Completed, setIsStep3Completed] = useState(false);
    const [isStep31aCompleted, setIsStep31aCompleted] = useState(false);
    const [isStep31bCompleted, setIsStep31bCompleted] = useState(false);
    const [isStep32Completed, setIsStep32Completed] = useState(false);

    const [siDelaiPrelevement, setSiDelaiPrelevement] = useState(false);
    const [datePremierPrelevement, setDatePremierPrelevement] = useState(null);
    const [dateDernierPrelevement, setDateDernierPrelevement] = useState(null);
    const [dateLivraison, setDateLivraison] = useState(null);
    const [montantMensualite, setMontantMensualite] = useState(null);
    const [montantTotal, setMontantTotal] = useState(null);
    const [nbMensualite, setNbMensualite] = useState(null);
    const [simulRecap, setSimulRecap] = useState(null);

    const [hideSliderPremierPrelevement, setHideSliderPremierPrelevement] = useState(true);
    const [hideSliderMontantMensualite, setHideSliderMontantMensualite] = useState(true);
    const [hideSliderMontantTotal, setHideSliderMontantTotal] = useState(true);
    const [hideSliderNbMensualite, setHideSliderNbMensualite] = useState(true);
    const [disableSignButton, setDisableSignButton] = useState(true);
    const [hideSliderHelp, setHideSliderHelp] = useState(true);
    const [disablePostButton, setDisablePostButton] = useState(true);
    const [disableNextStepButton, setDisableNextStepButton] = useState(false);
    const [isPhoneNumbersNotValid, setIsPhoneNumbersNotValid] = useState(false);
    const [isEcartDatePrelev, setIsEcartDatePrelev] = useState(false);
    const [isEcartQf, setIsEcartQf] = useState(false);

    const [activeIndex, setActiveIndex] = useState([]);
    const [step, setStep] = useState();
    const [justificatifPresence, setJustificatifPresence] = useState(null);
    const [retourJustificatifPresence, setRetourJustificatifPresence] = useState(false);
    const [hideJustificatif, setHideJustficatif] = useState(false);
    const fileUploadRef = useRef(null);

    const [policyOne, setPolicyOne] = useState(false);
    const [policyTwo, setPolicyTwo] = useState(false);
    const [policyThree, setPolicyThree] = useState(false);

    const [editCommande, setEditCommande] = useState(true);

    const toast = useRef(null);
    const [displayBasic, setDisplayBasic] = useState(false);
    const [showFileUploadError, setShowFileUploadError] = useState(false);
    const [showDemandeError, setShowDemandeError] = useState(false);

    const [disabled, setDisabled] = useState(false);
    const [codeError, setCodeError] = useState(false);

    const [demandeAncv, setDemandeAncv] = useState();

    const [numPages, setNumPages] = React.useState(0);
    const [contratFile, setContratFile] = useState(null);
    const [mandatFile, setMandatFile] = useState(null);

    const [paramDateJourPrelevement, setParamDateJourPrelevement] = React.useState(0);
    const [paramJourLivraision, setParamJourLivraision] = React.useState(0);
    const [paramJourLimite, setParamJourLimite] = React.useState(0);
    const [delaiPremPrelev, setDelaiPremPrelev] = React.useState(0);

    const [loaderRecap, setLoaderRecap] = useState(false);
    const [errorMsgRecap, setErrorMsgRecap] = useState(false);
    const MSG_LIMIT_RETRY_REACHED="Un problème technique bloque l'étape suivante pour le moment.\nRevenez dans quelques heures pour réessayer. \nLe C.G.O.S. fait tout pour rétablir le service rapidement.";
    const [errorMsgRetry, setErrorMsgRetry] = useState(MSG_LIMIT_RETRY_REACHED);
    const [loaderSign, setLoaderSign] = useState(false);
    const [isSignCompleted, setIsSignCompleted] = useState(false);
    const [limitRetryReached,setLimitRetryReached] = useState(false);

    // scroll
    const scrollToPaiementRef = useRef(null);
    const scrollToPrelevementRef = useRef(null);
    const scrollToPrelevementSliderRef = useRef(null);
    const scrollToDureeEpargneRef = useRef(null);
    const scrollToDureeEpargneSliderRef = useRef(null);
    const scrollToMontantEpargneRef = useRef(null);
    const scrollToMontantEpargneSliderRef = useRef(null);
    const scrollToMontantAchatRef = useRef(null);
    const scrollToMontantAchatSliderRef = useRef(null);

    //TODO recheck
    const ANCV_DATE_JOUR_PRELEVEMENT="JOUR.DATE.PREMIER.PRELEVEMENT.CONTRAT"; //Récuperation du bon parametrage de la date 1er prelev
    //Valeur Statique n'existe que dans le formulaire papier
    const ANCV_JOUR_LIVRAISON=25;
    const ANCV_JOUR_LIMITE="JOUR.LIMITE.VALIDATION.PRELEVEMENT.MOIS.SUIVANT";
    const ANCV_DELAI_MAXIMUM_PREMIER_PRELEV="DELAI_MAXIMUM_PREMIER_PRELEV";

    const MAYOTTE_CODE_DELEGATION="19";
    const MAYOTTE_CLASSIC_RECEPTION_NOTICE=<div><b>Les Chèques-vacances seront adressés à mon établissement qui me préviendra dès réception.</b>
    <br/>Des frais de gestion seront facturés avec le 1er prélèvement. J'ai bien vérifié que l'enseigne accepte les paiements avec le format CLASSIC.</div>;

    const CLASSIC_RECPTION_NOTICE=<div><b>Je recevrai les Chèques-vacances par courrier recommandé.</b>
    <br/>au plus tard le 25 du mois suivant celui du dernier prélèvement. Des frais de gestion seront facturés avec le 1er prélèvement. J'ai bien vérifié que l'enseigne accepte les paiements avec le format CLASSIC.</div>;



    let createMode = "create";
    let editMode = "edit";
    let mimeTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];

    // format nombre en Euro
    let formatEuro = Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
    });

    // format nombre fr
    let formatFr = Intl.NumberFormat('fr-FR', );

    // constitution de la liste des justifs à uploader en cas ce complément d'info
    let libelleJustifToDisplay = [];
    let codeJustifToUploadList = [];
    let cloneJustifToUploadList = [];


    const ancvService = new AncvService();
    const clapService = new ClapService();
    const chequeCultureService = new ChequeCultureService();
    const linkService = new LinkProviderService();
    const fileService = new FileService();
    const paramModuleService = new ParamModuleService();

      // Custom item template for DropDown
    const itemTemplate = (option) => {
        return (
        <div
            style={{
            color: option.disabled ? '#999' : 'inherit',
            pointerEvents: option.disabled ? 'none' : 'auto',
            opacity: option.disabled ? 0.7 : 1,
            }}
        >
            {option.name}
        </div>
        );
    };

    const selectFormatOptions = [
        {
            name: "CONNECT, le format digital",
            code: "0",
            disabled:isPhoneNumbersNotValid
        },
        {
            name: "CLASSIC, le format papier",
            code: "1",
            disabled:false
        },
    ];

    const selectParticipationOptions = [
        {
            name: "En plusieurs fois (EPARGNE)",
            code: "0",
        },
        {
            name: "En une seule fois (ACHAT)",
            code: "1",
        },
    ];

    const justificatifsCategories = [
        {
            "key": "106",
            "value": "Justificatif de présence en établissement",
            "description": "Bulletin de paie ou attestation de travail de moins d’un mois ou décision administrative de congés parental à 100%."
        }
    ];

    const text = <div><strong><p>POLITIQUE DE PROTECTION DES DONNÉES À CARACTÈRE PERSONNEL</p></strong><br />
        <p>J'ai bien noté que les données à caractère personnel renseignées dans le formulaire sont recueillies et traitées par le C.G.O.S, en sa qualité de responsable du traitement, pour le traitement de ma commande de Chèques-vacances ANCV.
            <br />Les données collectées sont indispensables à l'exécution de ce traitement et sont mis en œuvre sur les bases légales de la mission d’intérêt public et du respect d’obligations légales et réglementaires.
            Elles sont destinées aux services concernés du C.G.O.S ainsi qu’à l’ANCV et à ses sous-traitants ou prestataires.</p>
        <p>L’ANCV intervient en qualité de sous-traitant du C.G.O.S pour :</p>
        <p><ul>L’envoi postal des Chèques-vacances CLASSIC aux bénéficiaires ;</ul></p>
        <p><ul>L’envoi aux bénéficiaires d’un courrier électronique d’information sur l’attribution des Chèques-vacances CONNECT ;</ul></p>
        <p>L’ANCV intervient en qualité de responsable de traitement :</p>
        <p><ul>Pour l’émission des Chèques-vacances, la gestion des Chèques-vacances CONNECT avec comme base légale l’exécution d’un contrat conclu avec le C.G.O.S au profit des bénéficiaires.
        </ul></p>
        <p>Les données collectées seront conservées :</p>
        <p><ul>Par le C.G.O.S durant 10 ans à compter de la clôture de l’exercice comptable durant lequel la prestation a été délivrée,</ul></p>
        <p><ul>Par l’ANCV lorsqu’il agit en qualité de sous-traitant durant 5 ans à compter de la livraison des titres commandés et les documents comptables durant 10 ans.</ul></p>
        <p>Conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil sur les données (ci-après « RGPD ») et à la loi n° 78/17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés modifiée,</p>
        <p><ul>Je dispose d'un droit d’accès, de rectification ou d’effacement, de limitation du traitement de mes données personnelles, d’un droit d’opposition, d’un droit à la portabilité de mes données ainsi que du droit de définir des directives relatives au sort de ces données après mon décès.</ul>
            <ul>Pour exercer ce droit ou pour toute réclamation, je peux adresser un courrier au C.G.O.S à l'attention du Délégué à la Protection des Données : 101 rue de Tolbiac, 75654 PARIS CEDEX 13, ou un mail à l'adresse : dpd@cgos.asso.fr, en joignant à mon envoi par voie postale ou par mail une copie d'un titre d'identité.</ul></p>
        <p>Enfin, j’ai également le droit d’introduire une réclamation auprès de la Commission Nationale de l’Informatique et des Libertés (CNIL), autorité de contrôle en charge du respect des obligations en matière de données à caractère personnel.</p>
    </div>

    const editJustificatifMsg = ''

    const [sliderDatePrelevementOptions, setSliderDatePrelevementOptions] = useState({});
    const [sliderMontantMensualiteOptions, setSliderMontantMensualiteOptions] = useState({});
    const [sliderMontantTotalOptions, setSliderMontantTotalOptions] = useState({});
    const [sliderNbMensualiteOptions, setSliderNbMensualiteOptions] = useState({});

    useEffect(() => {
        if(createMode === mode) {
          fetchDataForCreation()
        } else if (editMode === mode) {
          fetchDataForEdition();
        } else {
          window.location.assign(linkService.getRetourEaLoginAgent());
        }
        if(!hasValidFrenchMobile(user)){
            setIsPhoneNumbersNotValid(true);
        }
    }, []);

    useEffect(() => {
        // si le tab suivant est l'affichage du preview, on désactive le simulateur pour figer les données
        if(step === 4) {
            setActiveIndex(prevState => [...prevState.filter(i => i !== 1), step]);
            if((hideJustificatif && createMode === mode) ||(editMode === mode && retourJustificatifPresence )){
                setActiveIndex(prevState => [...prevState.filter(i => i !== 2), step]);
            }
        } else if(isParamModuleOk){
            setActiveIndex(prevState => [...prevState, step]);
        }
        console.log("step changed to " + step);
    }, [step]);

    useEffect(() => {
        if(isParamModuleOk) {
            initActiveIndex();
            setStep(0);
        }
    }, [isParamModuleOk]);

    useEffect(() => {
        calcDates(ancvType, paiementType, datePremierPrelevement, nbMensualite);
        let simParams = null;
        if(paiementType === "0" && montantMensualite && nbMensualite) {
            simParams = {
                montantMensualite: montantMensualite,
                nombreMensualite: nbMensualite,
                exercice: actionSociale.exercice,
                numCgos: user.numCgos
            };
        } else if (paiementType === "1" && montantTotal) {
            simParams = {
                montantTotal: montantTotal,
                exercice: actionSociale.exercice,
                numCgos: user.numCgos
            };
        }
        getSimulationResults(simParams);
        setErrorMsgRecap(false);
    }, [ancvType, paiementType, datePremierPrelevement, nbMensualite, montantMensualite, montantTotal]);

    useEffect(() => {
        if(demandeAncv !== undefined) {
            previewContratMandat(demandeAncv);
        }
    }, [demandeAncv]);


    const hasValidFrenchMobile = (fiche) => {
        const pattern = /^(?:\+33|0)(6|7)\d{8}$/;
        const { telephonePortable, telephonePersonnel } = fiche;
        let isPortableValid=pattern.test(telephonePortable);
        let isPersonnelValid=pattern.test(telephonePersonnel);
      return (
              (telephonePortable != null && isPortableValid) ||
              (telephonePersonnel != null && isPersonnelValid)
            );
    }

    const isDifferentQf = (ficheQf, actualQf) => {
        // QF null équivaut à 'N.C.'
        const tmpFicheQf = ficheQf ? ficheQf : 'N.C';
        const tmpActualQf = actualQf ? actualQf : 'N.C';
        if(ficheQf !== 'N.C.' && actualQf !== 'N.C.') {
            return !floatsAreEqual(parseFloat(ficheQf),actualQf);
        }
        return 'N.C.';
    }

    const floatsAreEqual = (a, b, epsilon = 1e-10) => {
            return Math.abs(a - b) < epsilon;
    }


    const fetchDataForCreation = () => {
        getCurrentActionSociale();
        getJustificatifRequis();
        getRefBancaires();
    };

    const getParamModuleAncv = async (isJustifRequired) =>{

        try {
           const delaiRetardDodAndJustif=15;
           const {data} =  await paramModuleService.getParamByCodeCas(codeCasAncv);
           let paramJourLimiteTmp = data.find(obj => obj.pamCode === ANCV_JOUR_LIMITE).pamNumeriqueValeur;
           if (actionSociale.fiche.siDodEncours || isJustifRequired) {
               const newValue = paramJourLimiteTmp - delaiRetardDodAndJustif;
               paramJourLimiteTmp = newValue < 1 ? 1 : newValue;
           }
           const siDelaiPrelevementTmp = moment(Date.now()).date() > paramJourLimiteTmp;
           setParamDateJourPrelevement(data.find(obj => obj.pamCode === ANCV_DATE_JOUR_PRELEVEMENT).pamNumeriqueValeur);
           setParamJourLivraision(ANCV_JOUR_LIVRAISON);
           setParamJourLimite(paramJourLimiteTmp);
           setSiDelaiPrelevement(siDelaiPrelevementTmp);
           setDelaiPremPrelev(data.find(obj => obj.pamCode === ANCV_DELAI_MAXIMUM_PREMIER_PRELEV).pamNumeriqueValeur);
            // calcul de la date (mois) max du premier prélèvement
            // si le mois calculé en cours + délai prélèvement-1 <= décembre de l'exercice en cours, on choisit le mois calculé, sinon décembre
           let delaiPremPrelv=data.find(obj => obj.pamCode === ANCV_DELAI_MAXIMUM_PREMIER_PRELEV).pamNumeriqueValeur;
            let monthMax=12 - (new Date().getMonth()+1);
            let monthMaxSlider=monthMax > delaiPremPrelv ? delaiPremPrelv : monthMax;

            setSliderDatePrelevementOptions({
                symbolPrefix: "dans ",
                symbolSuffix: " mois",
                defaultValue: siDelaiPrelevementTmp ? 2 : 1,
                min: siDelaiPrelevementTmp ? 2 : 1,
                max: monthMaxSlider,
                labelMin: moment(Date.now()).add(siDelaiPrelevementTmp ? 2 : 1, "months").locale("fr").format("MMMM YYYY"),
                labelMax: moment(Date.now()).add(monthMaxSlider, "months").locale("fr").format("MMMM YYYY"),
                step: 1,
                width: "90%"
            });
           setIsParamModuleOk(true);
        } catch (error) {
           console.log(error);
        }
    }

    const  isPastDate =(dateStr)=> {
        const [day, month, year] = dateStr.map(Number);
        const inputDate = new Date(year, month - 1, day);
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        return inputDate < now;
    }

    const fetchDataForEdition = () => {
    

/*
        FORMULAIRE[0] = FORMAT_CHEQUES_ANCV
        FORMULAIRE[1] = FRAIS_DE_GESTION
        FORMULAIRE[2] = MODALITE_PARTICIPATION_AGENT (type de paiement EPARGNE ou ACHAT)
        FORMULAIRE[3] = MENSUALITE_NOMBRE_ANCV (si ACHAT égale à 1)
        FORMULAIRE[4] = MENSUALITE_MONTANT_ANCV (si ACHAT, égale à la participation agent renvoyé par le calcul du simulateur)
        FORMULAIRE[5] = MNT_EPARGNE_PREVIS_ANCV
        FORMULAIRE[6] = QUOTIENT_FAMILIAL
        FORMULAIRE[7] = PARTICIPATION_CGOS_ANCV
        FORMULAIRE[8] = BORNE_POURCENTAGE
        FORMULAIRE[9] = VALEUR_TOTALE_CHEQUIER_ANCV (montant total renvoyé par le calcul du simulateur)
        FORMULAIRE[10] = DATE_PREMIER_PRELEVEMENT_ANCV
        FORMULAIRE[11] = DATE_DERNIER_PRELEVEMENT_ANCV
        FORMULAIRE[12] = DATE_LIVRAISON_ANCV
        FORMULAIRE[13] = NUMERO_CONTRAT_EPARGNE_ANCV
        FORMULAIRE[14] = NUMERO_MANDAT_SEPA_ANCV
        FORMULAIRE[15] = BORNE_QF_MIN
        FORMULAIRE[16] = BORNE_QF_MAC
*/
         chequeCultureService.getEditDto().then((form) => {
            const oldForm=form.data;
            let jsonObj = JSON.parse(oldForm.formJson);
            let extractedAncvType=jsonObj.FORMULAIRE[0].VALEUR;
            let extractedPaiementType=jsonObj.FORMULAIRE[2].VALEUR;
            let extractedMontantTotal= parseFloat(jsonObj.FORMULAIRE[9].VALEUR);
            let extractedMontantMensualite=parseFloat(jsonObj.FORMULAIRE[4].VALEUR);
            let extractedNombreMensualite=parseInt(jsonObj.FORMULAIRE[3].VALEUR);
            let extractedFraisGestion=parseFloat(jsonObj.FORMULAIRE[1].VALEUR);
            let extractedMontantParticipationCgos=parseFloat(jsonObj.FORMULAIRE[7].VALEUR);

            let extractedBorneQfMin=parseFloat(jsonObj.FORMULAIRE[14].VALEUR);
            let extractedBorneQfMax=parseFloat(jsonObj.FORMULAIRE[15].VALEUR);
            let extractedBornePourcentage=parseFloat(jsonObj.FORMULAIRE[8].VALEUR);


            const oldSimulRecap = {
                       montantTotal: extractedMontantTotal,
                       montantMensualite: extractedMontantMensualite,
                       nombreMensualite: extractedNombreMensualite,
                       fraisGestion: extractedFraisGestion,
                       montantParticipationAgent: extractedMontantTotal-extractedMontantParticipationCgos,
                       montantParticipationCgos: extractedMontantParticipationCgos,
                       montantMaxParticipationCgos: 180,
                       borneQfMin:extractedBorneQfMin,
                       borneQfMax:extractedBorneQfMax,
                       bornePourcentage:extractedBornePourcentage
              };

              setAncvType(extractedAncvType === "CONNECT" ? "0" : "1");
              setPaiementType(extractedPaiementType === "EPARGNE" ? "0" : "1");


              setSimulRecap(oldSimulRecap);

              setIsStep1Completed(true);
              setIsStep2Completed(true);


              let extractedQf= jsonObj.FORMULAIRE[6].VALEUR === 'N.C.' ? jsonObj.FORMULAIRE[6].VALEUR : parseFloat(jsonObj.FORMULAIRE[6].VALEUR);


              if(isDifferentQf(actionSociale.fiche.quotientFamilial,extractedQf)){
                setIsEcartQf(true);
                setIsStep3Completed(true);
                setIsStep31aCompleted(true);
                setIsStep31bCompleted(true);
                setIsStep32Completed(true);
              }

            Object.values(oldForm.filesToUpload).forEach(file => {
            if(file.codeJustificatif === '106') {
                 setRetourJustificatifPresence(true);
              }
            });

            getCurrentActionSociale();
            getJustificatifRequis();
            getRefBancaires();
        });
    }


    const getCurrentActionSociale = () => {
        Object.values(actionSociale.listActionsSociale).forEach((as) => {
            if (
                as.codeActionSociale === actionSociale.cas &&
                as.exercice === actionSociale.exercice
            ) {
                setCurrentActionSociale(as);
                getBaremes(as);
                return;
            }
        });
    };

    //4) Recupération des baremes
    const getBaremes = async (actionSocial) => {
        const bareme = {
            casCode: actionSocial.codeActionSociale,
            delegId: actionSocial.codeDelegation,
            exercie: actionSocial.exercice,
            siActif: 1,
        };

        try {
            const {data} = await clapService.getBaremes(bareme);
            setBaremes(data);

            let valMax = 0;
            let val = 0;
            data.forEach((el, i) => {
                  if (valMax !== 0) return;
                  if(actionSociale.fiche.quotientFamilial == null){
                    valMax = data[data.length-1].plafond;
                    val = data[data.length-1].valeur;
                    return;
                   }
                  if (i === data.length - 1) {
                    if (Number(actionSociale.fiche.quotientFamilial.replace(",", ".")) >= Number(el.borne)) {
                      valMax = data[i].plafond;
                      val = data[i].valeur;
                    }
                  } else if (Number(actionSociale.fiche.quotientFamilial.replace(",", ".")) < Number(data[i + 1].borne)) {
                    valMax = el.plafond;
                    val = el.valeur;
                  }
            });
            setValMaxParticipation(valMax);
            setValParticipation(val);

            let borneMinAchat=150;
            setParticipationMaxCgos(data[0]?.participationMax);
            setParticipationMinCgos(parseInt(data[0]?.participationMin));

            setSliderMontantMensualiteOptions({
                symbolPrefix: "",
                symbolSuffix: " €",
                defaultValue: parseInt(data[0]?.montantMinMensuel),
                min: parseInt(data[0]?.montantMinMensuel),
                max: Math.ceil(parseInt(data[0]?.montantMaxMensuel) / 12),
                labelMin: parseInt(data[0]?.montantMinMensuel) + " €",
                labelMax: Math.ceil(parseInt(data[0]?.montantMaxMensuel) / 12) + " €",
                step: 10,
                width: "90%"
            });

            setSliderMontantTotalOptions({
                symbolPrefix: "",
                symbolSuffix: " €",
                defaultValue: Math.ceil(borneMinAchat/10)*10,
                min: Math.ceil(borneMinAchat/10)*10,
                max: parseInt(data[0]?.montantMaxMensuel),
                labelMin: Math.ceil(borneMinAchat/10)*10 + " €",
                labelMax: parseInt(data[0]?.montantMaxMensuel) + " €",
                step: 10,
                width: "90%"
            });

            setSliderNbMensualiteOptions({
                symbolPrefix: "",
                symbolSuffix: " mois",
                defaultValue: 4,
                min: 4,
                max: parseInt(data[0]?.nbMoisMax),
                labelMin: "4 mois",
                labelMax: parseInt(data[0]?.nbMoisMax) + " mois",
                step: 1,
                width: "90%"
            });
        } catch (error) {
            console.log(error);
        }
    };

    const getJustificatifRequis = async () => {
        chequeCultureService
            .getJustificatifRequis()
            .then((res) => {
                setHideJustficatif(res.data);
                getParamModuleAncv(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getRefBancaires = async () => {
        await clapService.getIbanMembre(user.numCgos).then((res) => {
            setRefBancaires(res.data);
        }).catch((error) => {
            console.log(error);
        });
    };

    const checkDemandeStatut = async (demandeId) => {
       return await ancvService.getDemandeStatut(demandeId);
    };


    const initActiveIndex = () => {
        if (createMode === mode) setActiveIndex([0]);
        if (editMode === mode) setActiveIndex([1,2]);
    };

    const nextStep = (element, increment) => {
        element.disabled = true;
        element.classList.add("disabled");
        element.style.pointerEvents = "none";
        element.style.display = "none";
        setStep(step + increment);
    };

    const showInfo = (msg) => {
        toast.current.show({
            severity: "info",
            summary: "Succès",
            detail: msg + " envoyée avec succès. ",
            life: 5000,
        });
    };

    const showErrorApi = (msg) => {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Une erreur est survenue. Nous faisons tout notre possible pour régler rapidement le problème. Merci de réessayer un peu plus tard",
                err: msg,
                life: 5000,
            });
   };

    const isInViewport = (element) => {
        requestAnimationFrame(() => {
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
            );
        })
    };

    const scrollIfNotVisible = (ref) => {
        const el = ref.current;
        if (el && !isInViewport(el)) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    const scrollBottomIfNotVisible = () => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }

    const handleChangeFormat = (value) => {
        setAncvType(value);
        setIsStep1Completed(value !== null);
        setTimeout(() => scrollIfNotVisible(scrollToPaiementRef), 100);
    };

    const handleChangeParticipation = (value) => {
        setPaiementType(value);
        setIsStep2Completed(value !== null);
        setTimeout(() => scrollIfNotVisible(scrollToPrelevementRef), 100);
    };


    const handleChangeDatePrelevement = (value) => {
        setSliderDatePrelevementOptions(prev => ({ ...prev, newValue: value }));
        setTimeout(() => scrollIfNotVisible(scrollToDureeEpargneRef), 100);
        setTimeout(() => scrollIfNotVisible(scrollToMontantAchatRef), 100);
    };

    const handleFinalizeDatePrelevement = (value) => {
        if(hideJustificatif){
            if(siDelaiPrelevement){
                setDatePremierPrelevement(moment(Date.now()).add(value, "months").date(paramDateJourPrelevement));
            }else{
                if(paiementType === "0"){
                    setDatePremierPrelevement(moment(Date.now()).add(value, "months").date(5));
                }else{
                    setDatePremierPrelevement(moment(Date.now()).add(value, "months").date(paramDateJourPrelevement));
                }
            }
        }else{
            if((siDelaiPrelevement)){
                setDatePremierPrelevement(moment(Date.now()).add(value, "months").date(paramDateJourPrelevement));
            }else{
                setDatePremierPrelevement(moment(Date.now()).add(value, "months").date(paramDateJourPrelevement));
            }
        }

        setIsStep3Completed(value !== null);
    };

    const handleChangeMontantMensualite = (value) => {
        setSliderMontantMensualiteOptions(prev => ({ ...prev, newValue: value }));
        scrollBottomIfNotVisible();
    };

    const handleFinalizeMontantMensualite = (value) => {
        setMontantMensualite(value);
        setIsStep31bCompleted(true);
    };

    const handleChangeNbMensualite = (value) => {
        setSliderNbMensualiteOptions(prev => ({ ...prev, newValue: value }));
        setTimeout(() => scrollIfNotVisible(scrollToMontantEpargneRef), 100);
    };

    const handleFinalizeNbMensualite = (value) => {
        setNbMensualite(value);
        setIsStep31aCompleted(true);
    };

    const handleChangeMontantTotal = (value) => {
        setSliderMontantTotalOptions(prev => ({ ...prev, newValue: value }));
        scrollBottomIfNotVisible();
    };

    const handleFinalizeMontantTotal = (value) => {
        setMontantTotal(value);
        setIsStep32Completed(value !== null);
    };

    const getSimulationResults = (simParams) => {
        if(!simParams) {
            setSimulRecap(null);
            return null;
        }
        ancvService.getSimulationResults(simParams).then((res) => {
            setSimulRecap({
                montantTotal: res.data.montantTotal,
                montantMensualite: res.data.montantMensualite,
                nombreMensualite: res.data.nombreMensualite,
                fraisGestion: res.data.fraisGestion,
                montantParticipationAgent: res.data.montantParticipationAgent,
                montantParticipationCgos: res.data.montantParticipationCgos,
                montantMaxParticipationCgos: res.data.montantMaxParticipationCgos,
                borneQfMin:res.data.borneQfMin,
                borneQfMax:res.data.borneQfMax,
                bornePourcentage : res.data.bornePourcentage
            });
        });
    };

    const calcDates = (ancvType, paiementType, datePremierPrelevement, nbMensualite) => {
        if ((paiementType === "0" && (!datePremierPrelevement || !nbMensualite)) || (paiementType === "1" && !datePremierPrelevement)) {
            setDateLivraison(null);
            return null;
        }

        /*
                Calcul date de livraison:
                    A - prélèvement unique/1er : indiqué par l'agent
                    B - nombre de mois de prélèvement demandé (épargne) : indiqué par l'agent
                    C - Mois dernier prélèvement : calcul = A + B
                    D - Jour prélèvement mensuel : paramètre : jour = 5 du mois correspondant
                    E - Date livraison Connect : 15 du C
                    F - Date livraison Classic : 15 du C+1
        */
        const dateDernierPrelev = moment(new Date(datePremierPrelevement)).add(paiementType === "0" ? nbMensualite-1 : 0, "months").date(paramDateJourPrelevement);
        setDateDernierPrelevement(dateDernierPrelev);

        setDateLivraison(moment(new Date(dateDernierPrelev)).add(1, "months").date(paramJourLivraision));
    };

    const isSimulateurOk = (ancvType, paiementType) => {
        if(!simulRecap) {
            return false;
        } else if(ancvType !== "0" && ancvType !== "1") {
            return false;
        } else if(ancvType === "1" && !simulRecap.fraisGestion) {
            return false;
        } else if(paiementType === "0") {
            if(!(simulRecap.montantTotal && simulRecap.montantMensualite && simulRecap.nombreMensualite && simulRecap.montantParticipationAgent && simulRecap.montantParticipationCgos)) {
                return false;
            } else if(!(dateLivraison && nbMensualite && montantMensualite)) {
                return false;
            } else if(simulRecap.montantParticipationCgos < participationMinCgos) {
                return false;
            } else {
                return true;
            }
        } else if(paiementType === "1") {
            if(!(simulRecap.montantTotal && simulRecap.montantParticipationAgent && simulRecap.montantParticipationCgos)) {
                return false;
            } else if(!(dateLivraison && montantTotal)) {
                return false;
            } else if(simulRecap.montantParticipationCgos < participationMinCgos) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    const calcMontantPremierPrelevement = (ancvType) => {
        if(ancvType === "0") {
            if(paiementType === "0") {
                return simulRecap?.montantMensualite;
            } else if(paiementType === "1") {
                return simulRecap?.montantParticipationAgent;
            }
        } else if(ancvType === "1") {
            if(paiementType === "0") {
                return (simulRecap?.montantMensualite + simulRecap?.fraisGestion);
            } else if(paiementType === "1") {
                return (simulRecap?.montantParticipationAgent + simulRecap?.fraisGestion);
            }
        } else {
            return "";
        }
    }

    const canRetryCallBackEnd = () =>{
        if (!canRetry(user.numCgos)) {
            setErrorMsgRetry(MSG_LIMIT_RETRY_REACHED);
            setLimitRetryReached(true);
            setLoaderRecap(false);
            setErrorMsgRecap(true);
            return true;
        }
        return false;
    }

    const submitFormDemande = (e) => {

        e.preventDefault();
        if(e.detail == 1) {
            if (canRetryCallBackEnd()) {
                return;
            }
            const jsonFormSchemaJustif = {
                formulaire: [
                    {
                        "code": "FORMAT_CHEQUES_ANCV",
                        "valeur": ancvType === "0" ? "CONNECT" : "CLASSIC"
                    },
                    {
                        "code": "FRAIS_DE_GESTION",
                        "valeur": ancvType === "0" ? "0" : simulRecap.fraisGestion?.toString()
                    },
                    {
                        "code": "MODALITE_PARTICIPATION_AGENT",
                        "valeur": paiementType === "0" ? "EPARGNE" : "ACHAT",
                    },
                    {
                        "code": "MENSUALITE_NOMBRE_ANCV",
                        "valeur": paiementType === "0" ? simulRecap.nombreMensualite?.toString() : "1"
                    },
                    {
                        "code": "MENSUALITE_MONTANT_ANCV",
                        "valeur": paiementType === "0" ? simulRecap.montantMensualite?.toString() : simulRecap?.montantParticipationAgent?.toString()
                    },
                    {
                        "code": "MNT_EPARGNE_PREVIS_ANCV",
                        "valeur": paiementType === "0" ? (simulRecap.nombreMensualite * simulRecap.montantMensualite)?.toString() : simulRecap?.montantParticipationAgent?.toString()
                    },
                    {
                        "code": "QUOTIENT_FAMILIAL",
                        "valeur": actionSociale.fiche.quotientFamilial !== null ? actionSociale.fiche.quotientFamilial?.toString() : 'N.C.'
                    },
                    {
                        "code": "PARTICIPATION_CGOS_ANCV",
                        "valeur": simulRecap.montantParticipationCgos?.toString()
                    },
                    {
                        "code": "BORNE_POURCENTAGE",
                        "valeur": simulRecap.bornePourcentage?.toString()
                    },
                    {
                        "code": "VALEUR_TOTAL_CHEQUIER_ANCV",
                        "valeur": simulRecap.montantTotal?.toString()
                    },
                    {
                        "code": "DATE_PREMIER_PRELEVEMENT_ANCV",
                        "valeur": datePremierPrelevement.locale("fr").format("DD/MM/yyyy")
                    },
                    {
                        "code": "DATE_DERNIER_PRELEVEMENT_ANCV",
                        "valeur": dateDernierPrelevement.locale("fr").format("DD/MM/yyyy")
                    },
                    {
                        "code": "DATE_LIVRAISON_ANCV",
                        "valeur": dateLivraison.locale("fr").format("DD/MM/yyyy")
                    },
                    {
                        "code": "NUMERO_CONTRAT_EPARGNE_ANCV",
                        "valeur": "10"
                    },
                    {
                        "code": "NUMERO_MANDAT_SEPA_RUM_ANCV",
                        "valeur": "20"
                    },
                    {
                        "code": "BORNE_QF_MIN",
                        "valeur": simulRecap.borneQfMin?.toString()
                    },
                    {
                        "code": "BORNE_QF_MAX",
                        "valeur": simulRecap.borneQfMax?.toString()
                    }

                ]
            };


            const demandeDetail = {
                id: editMode === mode ? oldForm.demandeDetailId : "",
                demandeType: {
                    codeActionSocial: editMode === mode ? oldForm.codeActionSociale : currentActionSociale.codeActionSociale,
                },
                motif: ancvType === "0" ? "CONNECT" : "CLASSIC",
                formJson: JSON.stringify(jsonFormSchemaJustif).toUpperCase(),
                montant: simulRecap.montantTotal,
                version: "1",
            };

            let justificatifsPresenceList = [];

            if (actionSociale.optJustificatif && justificatifPresence && justificatifPresence.length > 0) {
                Object.values(justificatifPresence).forEach(jus => {
                    justificatifsPresenceList.push(jus.category[1]);
                });
            }

            const contratAncv = {
                id: editMode === mode ? oldForm.contratId : "",
                "typeContrat": ancvType === "0" ? "CONNECT" : "CLASSIC",
                "numCgos": user.numCgos,
                "etbCode": user.codeEtablissement,
                "nomEtb": user.libelleEtablissement,
                "quotientFamilial": actionSociale.fiche.quotientFamilial,
                "agentCivilite": user.civilite,
                "agentNom": user.nom,
                "agentPrenom": user.prenom,
                "agentAdresse": [user.adresse.adresse1, user.adresse.adresse2, user.adresse.adresse3, user.adresse.adresse4].filter(Boolean).join(" "),
                "agentCodePostal": user.adresse.codePostal,
                "agentVille": user.adresse.ville,
                "agentEmail": user.email,
                "numeroTelMobile": user.telephonePortable,
                "montantMensuelEpargne": paiementType === "0" ? simulRecap.montantMensualite : simulRecap?.montantParticipationAgent,
                "nombreMensualite": paiementType === "0" ? simulRecap.nombreMensualite : "1",
                "montantPremierPrelevementAvecFrais": calcMontantPremierPrelevement(ancvType),
                "datePrelevement": datePremierPrelevement.locale("fr").format("DD-MM-yyyy"),
                "iban": refBancaires?.numIBan,
                "dateDebutTempsEpargne": datePremierPrelevement.locale("fr").format("DD-MM-yyyy"),
                "dateFinTempsEpargne": dateDernierPrelevement.locale("fr").format("DD-MM-yyyy"),
                "totalFinContrat": paiementType === "0" ? simulRecap.nombreMensualite * simulRecap.montantMensualite : simulRecap?.montantParticipationAgent,
                "participationCgos": simulRecap.montantParticipationCgos,
                "valeurTotaleCheque": simulRecap.montantTotal,
                "dateReception": dateLivraison.locale("fr").format("DD-MM-yyyy")
            };

            const mandatSepa = {
                id: editMode === mode ? oldForm.mandatId : "",
                "debiteurNom": user.nom,
                "debiteurPrenom": user.prenom,
                "debiteurAdresse": [user.adresse?.adresse1, user.adresse?.adresse2, user.adresse?.adresse3].filter(Boolean).join(" "),
                "debiteurBoitePostal": user.adresse?.adresse4,
                "debiteurCodePostal": user.adresse.codePostal,
                "debiteurVille": user.adresse.ville,
                "debiteurPays": user.adresse.pays,
                "debiteurIban": refBancaires.numIBan,
                "debiteurBic": refBancaires.bic,
                "creancierNom": "C.G.O.S (Comité de Gestion des Oeuvres Sociales des Etablissements hospitaliers publics)",
                "creancierAdresseComplete": "101 rue de Tolbiac - 75654 PARIS CEDEX 13 - France",
                "creancierSepa": "FR43ZZZ339415",
                "objetPrelevement": "Participation CHEQUES-VACANCES",
                "dateSignatureMandat": moment(new Date()).locale("fr").format("DD-MM-yyyy"),
                "typePaiement": paiementType === "0" ? "EPARGNE" : "ACHAT",
                "echeancePrelevement": paramDateJourPrelevement
            };

            const demande = {
                etape: "1",
                origine: "NEA",
                exercice: editMode === mode ? oldForm.exercice : currentActionSociale.exercice,
                codeClasseur: currentActionSociale.codeActionSociale,
                numeroCGOS: user.numCgos,
                statut: "A_VALIDER",
                demandeStatutReferentiel: {id: 1},
                demandeDetails: [],
                contratAncv: contratAncv,
                mandatSepa: mandatSepa,
                id: editMode === mode ? oldForm.demandeId : demandeAncv?.id
            };


            demande.demandeDetails.push(demandeDetail);

            if (hideJustificatif || (editMode === mode && retourJustificatifPresence)) {
                if (justificatifPresence && justificatifPresence.length > 0) {
                    setDisabled(true);
                    fileService
                        .uploadMultiFile(justificatifPresence)
                        .then((res) => {
                            if (null != res.data && res.data != undefined) {
                                // showInfo("Justificatif");
                                editMode === mode ? saveEditedDemande(demande) : saveDemande(demande);
                            } else {
                                setShowFileUploadError(true);
                            }
                        })
                        .catch((err) => {
                            window.location =
                                "/#/serviceIndisponible/" + err.response.data.errorId;
                        });
                } else {
                    // showInfo("Justificatif");
                    editMode === mode ? saveEditedDemande(demande) : saveDemande(demande);

                }
                ;
            } else {
                // showInfo("Justificatif");
                editMode === mode ? saveEditedDemande(demande) : saveDemande(demande);
            }
        }
    };

    const saveDemande = async (demande) => {
        await chequeCultureService
            .submitDemandeGuarded(demande)
            .then((res) => {
                demande.id = res.data.id;
                setDemandeAncv(demande);
                // setDisplayBasic(true);
                // showInfo("Demande");
                //loading to call this
                checkDemandeStatut(res.data.id).then((res2) => {
                    if(res2.data === "REFUSE"){
                        setLoaderRecap(false);
                        setErrorMsgRecap(true);
                    }
                }).catch((err) => {
                    // showErrorApi(err.response.data.errorId);
                    setLoaderRecap(false);
                    setErrorMsgRecap(true);
                });
            }).catch((e) => {

              setErrorMsgRecap(true);

            });

    };

    const previewContratMandat = async (demandeAncv) => {
//        console.log("previewContratMandat");
        if(canRetryCallBackEnd()){
            return;   
        }
        await ancvService.previewContrat(demandeAncv).then((res) => {
            const blob = new Blob([res.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            setContratFile(url);
            // preview mandat
            ancvService.previewMandat(demandeAncv).then((res) => {
                const blob = new Blob([res.data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                setMandatFile(url);
                setDisableSignButton(false);
                setErrorMsgRecap(false);
                const nextButtonRecap = document.getElementsByClassName("next-button-recap")[0];
                nextStep(nextButtonRecap, 1);
            }).catch((e) => {
                    setErrorMsgRecap(true);
            });
        }).catch((e) => {
                setErrorMsgRecap(true);
        }).finally(() => {
            setLoaderRecap(false);
        });
    };

    const saveEditedDemande = async (demande) => {
       await ancvService
            .submitEditedFormWithContracts(demande)
            .then((res) => {
                demande.id = res.data.id;
                setDemandeAncv(demande);
            })
            .catch((err) => {
                setLoaderRecap(false);
                setErrorMsgRecap(true);
            });
    };

    const signAndSendContratMandat = (demande, e) => {
        e.preventDefault();
        if(canRetryCallBackEnd()){
            return;   
        }
        ancvService.signContrat(demande).then((res) => {
            ancvService.signMandat(demande).then((res) => {
                ancvService.submitContratMandat(demande).then((res) => {
                    resetRetry();
                    setDisplayBasic(true);
                    setLoaderSign(false);
                    setIsSignCompleted(true);
                    const boutonS = document.getElementById('mes-suivis');
                    const boutonR = document.getElementById('retour-accueil');

                    boutonS.addEventListener('mouseover', function () {
                        boutonS.style.backgroundColor = '#39b0c8';
                        boutonS.style.color = '#333031';
                        boutonS.style.borderColor = '#999898';
                    });
                    boutonR.addEventListener('mouseover', function () {
                        boutonR.style.backgroundColor = '#cccbcc';
                        boutonR.style.color = '#333031';
                        boutonR.style.borderColor = '#333031';
                    });
                    boutonS.addEventListener('mouseout', function () {
                        boutonS.style.backgroundColor = '#2A7D93';
                        boutonS.style.color = '#ffffff';
                        boutonS.style.borderColor = '#999898';
                    });
                    boutonR.addEventListener('mouseout', function () {
                        boutonR.style.backgroundColor = '#ffffff';
                        boutonR.style.color = '#333031';
                        boutonR.style.borderColor = '#333031';
                    });
                }).catch((err) => {
                    window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
                });
                //setDisablePostButton(false);
            }).catch((err) => {
                window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
            });
        }).catch((err) => {
            window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
        });
        
    };

    const handleAnnuler = () => {
        chequeCultureService.redirectEaLegacy();
    };

    const onPolicyOneChange = () => {
        setPolicyOne(!policyOne);
    };

    const onPolicyTwoChange = () => {
        setPolicyTwo(!policyTwo);
    };
    const onPolicyThreeChange = () => {
        setPolicyThree(!policyThree);
    };

    const logoutRemoveDataMesSuivis = (e) => {
        chequeCultureService.logOut().then((res) => {
            console.log(res);
        });
        chequeCultureService.redirectEaLegacySuiviDemandes();
    };

    const logoutRemoveData = (e) => {
        chequeCultureService.logOut().then((res) => {
            console.log(res);
        });
        handleAnnuler();
    };


     const basicDialogFooter = (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
            
            <button
                type="button"
                onClick={(e) => logoutRemoveData(e)}
                className="retour-accueil-btn"
                id="retour-accueil"
                style={{color: '#333031', backgroundColor: '#ffffff', border: '1px solid #333031', padding: '0.5rem 1rem', fontSize: '1rem', borderRadius: '5px'}}
                >
                RETOUR A L'ACCUEIL
            </button>

            <button
                type="button"
                onClick={(e) => logoutRemoveDataMesSuivis(e)}
                className="mes-suivis-btn"
                id="mes-suivis"
                style={{color: '#ffffff', backgroundColor: '#2A7D93', border: '1px solid #999898', padding: '0.5rem 1rem', fontSize: '1rem', borderRadius: '5px'}}
                >
                MES SUIVIS
            </button>
        </div>
      );

    return (
        <div className="content-wrapper">
            <form onSubmit={(e) => e.preventDefault()} aria-label="Formulaire chèques-vacances">
                {editMode === mode && isParamModuleOk && (
                <>
                      <div className="error">
                          {libelleJustifToDisplay.length > 0 && (
                              <>
                                Observations du C.G.O.S sur les documents déjà transmis :
                                {Object.entries(libelleJustifToDisplay).map(([key, val]) => (
                                    <li>{val}</li>
                                ))}
                                <br/>
                                <br/>
                              </>

                          )}

                          {oldForm.noteRetourAgent && (
                              <>
                                Autre commentaire ou document complémentaire à nous envoyer :
                                <p>{oldForm.noteRetourAgent}</p>
                                <br/>
                              </>
                          )}

                              <b>Merci de renvoyer dans ce formulaire, après correction, les documents indiqués ci-dessous</b> (même nombre et mêmes types).

                     </div>
                     <div className="form-row-separator-20"/>
                </>
                )}

                {!isParamModuleOk && (
                    <>
                        <p className="error">
                            <b>Problème technique inattendu !</b><br/>
                            Le formulaire ne peut pas être affiché pour l’instant.<br/><br/>
                            Essayez à un autre moment.<br/>
                            Ou cliquez sur {' '} <a href={linkService.getRetourEaMembrePrestation()} className="clickable-link">PRESTATION ET FORMULAIRES</a> et réessayer maintenant.
                        </p>
                        <div className="form-row-separator-10"></div>
                    </>
                )}
             

                <Accordion activeIndex={activeIndex} multiple onTabChange={(e) => setActiveIndex(e.index)}>

                    <AccordionTab headerClassName="cgos-h3" header="1 - Je contrôle mes informations personnelles" disabled={true}>
                        <div>
                            <p className="success">
                                <b>INFO</b> : si certaines informations ne sont pas à jour, modifiez-les depuis la{' '}
                                <a href={linkService.getRetourEaMesInfo()} className="clickable-link">rubrique Mes infos</a>, ou{' '}
                                <a href={linkService.getRetourEaContacterNousChangeSituations()} className="clickable-link">Prévenir d’un changement de situation</a>.<br/>
                                Attendez-ensuite quelques jours, puis demandez votre prestation en ligne.​
                            </p>
                        </div>

                        <div className="form-row-separator-20"></div>

                        {/* Step 0: Identite */}
                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="identity-legend">
                                <table>
                                    <thead>
                                        <tr>
                                            <th id="identity-legend" colSpan="2">Mes informations personnelles</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Numéro C.G.O.S</td>
                                            <td>{user.numCgos}</td>
                                        </tr>
                                        <tr>
                                            <td>Etablissement</td>
                                            <td>{user.libelleEtablissement}</td>
                                        </tr>
                                        <tr>
                                            <td>Prénom</td>
                                            <td>{user.prenom}</td>
                                        </tr>
                                        <tr>
                                            <td>Nom</td>
                                            <td>{user.nom}</td>
                                        </tr>
                                        <tr>
                                            <td>Nom de naissance</td>
                                            <td>{user.nomNaissance}</td>
                                        </tr>
                                        <tr>
                                            <td>Email personnel</td>
                                            <td>{user.email}</td>
                                        </tr>
                                        <tr>
                                           <td>Tél. mobile</td>
                                           <td>{user.telephonePortable}</td>
                                        </tr>
                                        <tr>
                                           <td>Tél. personnel</td>
                                           <td>{user.telephonePersonnel}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div className="form-block-info">
                               <p className="help-important">
                                  <b>IMPORTANT : Si ce n’est pas déjà fait, remplacez impérativement votre email professionnel par un email personnel.</b><br/>
                                  Sinon les informations pour vos chèques-vacances pourraient être bloquées par la sécurité informatique de votre établissement.
                                  Cela garantit aussi la confidentialité et le suivi si vous changez d’établissement.<br/>
                                  Changez d'email depuis la rubrique  <a href={linkService.getEaModificationMail()} style={{ color: 'blue' }}>Mes Infos > Modifier mon adresse email.</a>
                               </p>
                           {isPhoneNumbersNotValid &&
                               <p className="help">
                                  <b>Pour commander des chèques au format CONNECT vous devez d’abord transmettre un numéro de téléphone Mobile.</b><br/>
                                  Ce numéro servira avec votre smartphone pour utiliser l'application mobile Chèques-Vacances ANCV.<br/>
                                 Pour transmettre votre numéro, allez à la rubrique  <a href={linkService.getEaModificationMail()} style={{ color: 'blue' }}>Mes Infos > Données personnelles.</a>
                               </p>
                            }
                            </div>


                        </div>

                        <div className="form-row-separator-10"></div>

                        {/* Step 0: Adresse */}
                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="address-legend">
                                <table>
                                    <thead>
                                    <tr>
                                        <th id="address-legend" colSpan="2">Mon adresse personnelle</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>N° et voie</td>
                                        <td>{user?.adresse?.adresse3}</td>
                                    </tr>
                                    <tr>
                                        <td>Lieu-dit</td>
                                        <td>{user?.adresse?.adresse4}</td>
                                    </tr>
                                    <tr>
                                        <td>Ville</td>
                                        <td>{user?.adresse?.ville}</td>
                                    </tr>
                                    <tr>
                                        <td>Pays</td>
                                        <td>{user?.adresse?.pays}</td>
                                    </tr>
                                    <tr>
                                        <td>Code postal</td>
                                        <td>{user?.adresse?.codePostal}</td>
                                    </tr>
                                    <tr>
                                        <td>Apprt., escalier</td>
                                        <td>{user?.adresse?.adresse1}</td>
                                    </tr>
                                    <tr>
                                        <td>Bâtiment, entrée, résidence</td>
                                        <td>{user?.adresse?.adresse2}</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>

                        <div className="form-row-separator-10"></div>

                        {/* Step 0: Références bancaires */}
                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="bank-legend">
                                <table>
                                    <thead>
                                    <tr>
                                        <th id="bank-legend" colSpan="2">Mes références bancaires</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Nom du titulaire</td>
                                        <td>{refBancaires.nomTitulaire}</td>
                                    </tr>
                                    <tr>
                                        <td>Compte</td>
                                        <td>{refBancaires.numIBan}</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div className="form-block-info">
                            <p className="help">
                                  <b>Ces références bancaires sont-elles à jour ?</b><br/>
                                  Sinon, changez-les depuis la page des <a href={linkService.getRetourEaPreferenceBancaires()} style={{ color: 'blue' }}>Références bancaires</a>
                               </p>

                            </div>
                        </div>

                        <div className="form-row-separator-10"></div>

                        {/* Step 0: Quotient familial */}
                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="qf-legend">
                                <table>
                                    <thead>
                                    <tr>
                                        <th id="qf-legend" colSpan="2">Mon quotient familial</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Quotient Familial (QF)</td>
                                        <td>{actionSociale.fiche.quotientFamilial !== null ? actionSociale.fiche.quotientFamilial : 'N.C.'}</td>
                                    </tr>
                                    <tr>
                                        <td>Participation C.G.O.S  maximum pour ce QF</td>
                                        <td>{formatEuro.format(valMaxParticipation)}</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                            {(!actionSociale.fiche.quotientFamilial) && <div className="form-block-info">
                                <p className="help">
                                    <b>Lorsque le QF n'est pas connu, la prestation du C.G.O.S est minimale.</b><br/>
                                    Pour bénéficier d'une prestation calculée selon votre quotient familial C.G.O.S, transmettez votre avis d'impôt depuis la rubrique
                                    <a href={linkService.getRetourEaContacterNousChangeSituations()} target="_blank" style={{ color: 'blue' }}>
                                        {" "}Prévenir d’un changement de situation.{" "}
                                    </a>
                                </p>
                            </div>}
                        </div>

                        <div className="form-row-separator-20"></div>

                        {(mode == createMode) && <div className="next-button-wrapper">
                            <button type="button"
                                    className="next-button button-arrow"
                                    onClick={(e) => nextStep(e.target, 1)}>
                                Etape suivante
                            </button>
                        </div>}
                    </AccordionTab>

                    <AccordionTab headerClassName="cgos-h3" header="2 - Je complète ma demande de chèque-vacances" disabled={true}>

                        <div className="form-row-separator-10"></div>

                        {/* Step 1: Format */}
                        <div className="form-row">
                            <fieldset className="form-block-wrapper" aria-labelledby="format-legend">
                                    <legend id="format-legend">
                                        <h4 className="cgos-h4">
                                            Je choisis le format{" "}
                                            <span className="select-value">
                                                <Dropdown
                                                    name="format"
                                                    value={ancvType}
                                                    placeholder="Sélectionnez un format"
                                                    options={selectFormatOptions}
                                                    optionLabel="name"
                                                    optionValue="code"
                                                    itemTemplate={itemTemplate}
                                                    onChange={(e) => {
                                                        handleChangeFormat(e.value);
                                                    }}
                                                    disabled={editMode === mode}
                                                    aria-labelledby="format-legend"
                                                />
                                            </span>
                                        </h4>
                                    </legend>

                            </fieldset>

                            <div className="form-block-info">
                                {ancvType && ancvType === "0" && (
                                  <>
                                    <p className="notice">
                                      <b>{"Je dispose d'un smartphone récent (5 ans ou moins)."}</b><br />
                                      Avant de choisir le format CONNECT, je vérifie si mon smartphone peut télécharger l’application Chèques-Vacances ANCV ou être mis à jour (Android 9, iOS 15).
                                      {" Je m'assure que les enseignes auxquelles je pense acceptent le paiement CONNECT."}
                                    </p>

                                    <p className="notice">
                                      <b>Mon numéro de mobile et mon email ne sont pas partagés avec un autre agent.</b><br />
                                      Si un proche utilise le même numéro que moi et/ou le même email pour commander à son nom des chèques vacances, l’application ANCV n’autorisera pas l’accès au compte CONNECT ni aux chèques-vacances commandés.
                                      <br />
                                      Avant de commander,{" "}
                                      <a href={linkService.getEaModificationPhone()} style={{ color: "blue" }}>
                                        j’enregistre des numéros et/ou des emails différents pour chacun.
                                      </a>
                                    </p>
                                  </>
                                )}

                                {ancvType && ancvType === "1" && (
                                    <p className="notice">
                                    {user.codeDelegation==MAYOTTE_CODE_DELEGATION ? MAYOTTE_CLASSIC_RECEPTION_NOTICE:CLASSIC_RECPTION_NOTICE}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="form-row-separator-30"></div>

                        {/* Step 2: Participation */}
                        {isStep1Completed && (
                        <div className="form-row">
                                <fieldset className="form-block-wrapper" aria-labelledby="participation-legend">
                                    <div ref={scrollToPaiementRef} className="format-flex">
                                        <legend id="participation-legend">
                                            <h4 className="cgos-h4">
                                                Je choisis de payer{" "}
                                                <span className="select-value">
                                                    <Dropdown
                                                        name="participation"
                                                        value={paiementType}
                                                        placeholder="Sélectionnez comment"
                                                        options={selectParticipationOptions}
                                                        optionLabel="name"
                                                        optionValue="code"
                                                        onChange={(e) => {
                                                            handleChangeParticipation(e.value);
                                                        }}
                                                        disabled={editMode === mode}
                                                        aria-labelledby="participation-legend"
                                                    />
                                                </span>
                                            </h4>
                                        </legend>
                                    </div>
                                </fieldset>

                            <div className="form-block-info">
                                {paiementType && paiementType === "0" && (
                                    <p className="notice"><b>Cela me permettra d’épargner sur plusieurs mois avant de recevoir mes Chèques-vacances.</b><br/>Paiement par prélèvement directement sur mon compte en banque.</p>
                                )}
                                {paiementType && paiementType === "1" && (
                                    <p className="notice"><b>Je recevrais mes chèques-vacances plus vite.</b><br/>Paiement par prélèvement directement sur mon compte en banque.</p>
                                )}
                            </div>
                        </div>
                        )}

                        <div className="form-row-separator-30"></div>

                        {/* Step 3: Mois du prélèvement */}
                        {isStep2Completed && (
                            <div className="form-row" style={{border: isEcartDatePrelev || isEcartQf ? '3px solid #e56d68' : ''}}>
                                <fieldset className="form-block-wrapper" aria-labelledby="prelevement-legend">
                                    <div ref={scrollToPrelevementRef}>
                                        <legend id="prelevement-legend">
                                            <h4 className="cgos-h4">
                                                {paiementType === "0" ? 'Je souhaite faire débuter les prélèvements le ' : 'Je souhaite être prélevé le '}
                                                <span onClick={() => {
                                                    setHideSliderPremierPrelevement(hideSliderPremierPrelevement => !hideSliderPremierPrelevement);
                                                    setTimeout(() => scrollIfNotVisible(scrollToPrelevementSliderRef), 100);
                                                }}
                                                    className="slider-value">{datePremierPrelevement ? datePremierPrelevement.locale("fr").format("D MMMM YYYY") : 'sélectionnez une date'}</span>
                                                {' '}<span className="icon-help pi pi-question-circle" hidden={hideSliderPremierPrelevement} onClick={() => setHideSliderHelp(hideSliderHelp => !hideSliderHelp)} />
                                            </h4>
                                        </legend>
                                    </div>
                                    {!hideSliderPremierPrelevement && (
                                        <div ref={scrollToPrelevementSliderRef}>
                                            <CustomSlider
                                                name="date-prelevement"
                                                options={sliderDatePrelevementOptions}
                                                value={sliderDatePrelevementOptions.newValue ?? sliderDatePrelevementOptions.defaultValue}
                                                onChange={handleChangeDatePrelevement}
                                                onSlideEnd={handleFinalizeDatePrelevement}
                                                aria-labelledby="prelevement-legend"
                                            />
                                        </div>
                                    )}
                                </fieldset>

                                <div className="form-block-info">
                                    {(paiementType === "1" && isStep3Completed) && (
                                        <p className="notice">
                                            <b>Info prélèvement</b><br/>
                                            Si le prélèvement échoue ou ne peut avoir lieu à la date prévue, le contrat sera automatiquement annulé.
                                        </p>
                                    )}
                                    {(paiementType === "1" && dateLivraison && isStep3Completed) && (sliderDatePrelevementOptions.newValue !== sliderDatePrelevementOptions.min) && (
                                        <p className="help">
                                            <b>Astuce réception</b><br/>
                                            Si la date de réception est trop juste pour votre départ en vacances, reculer la date du prélèvement.
                                        </p>
                                    )}
                                    {(paiementType === "1" && dateLivraison && isStep3Completed) && (
                                        <div className="notice-field">
                                            <div className="notice-field-row">
                                                <p class="field-label">
                                                    <b>Date de réception</b> au plus tard le<br/>
                                                    (estimation non contractuelle)
                                                </p>
                                                <span className="field-value">{dateLivraison?.locale("fr").format("D MMMM YYYY")}</span>
                                            </div>
                                        </div>
                                    )}
                                    {(!hideSliderHelp) && (
                                        <p className="help">
                                            <b>Comment choisir une valeur entre le minimum et le maximum ?</b><br/>
                                            <br/>
                                            <b>Avec une souris</b> : Cliquez sur le curseur, maintenez le bouton appuyé, puis faites glisser vers la gauche ou la droite jusqu’à la valeur souhaitée. Relâchez pour valider.<br/>
                                            <br/>
                                            <b>Avec une surface tactile</b> : Placez votre doigt sur le curseur, faites glisser doucement vers la gauche ou la droite jusqu’à la valeur souhaitée, puis relâchez pour valider.
                                        </p>
                                    )}

                                </div>
                            </div>
                        )}

                        <div className="form-row-separator-30"></div>

                        {/* Step 3-1a: Epargne */}
                        {isStep2Completed && isStep3Completed && paiementType === "0" && (
                        <>
                            <div className="form-row" style={{border: isEcartDatePrelev || isEcartQf ? '3px solid #e56d68' : ''}} ref={scrollToDureeEpargneRef}>
                                <fieldset className="form-block-wrapper"
                                          aria-labelledby="savings-duration-legend">
                                    <legend id="savings-duration-legend">
                                        <h4 className="cgos-h4">
                                            Durée de mon épargne {' '}
                                            <span onClick={() => {
                                                setHideSliderNbMensualite(hideSliderNbMensualite => !hideSliderNbMensualite);
                                                setTimeout(() => scrollIfNotVisible(scrollToDureeEpargneSliderRef), 100);
                                            }}
                                                  className="slider-value">{nbMensualite ? nbMensualite + ' mois' : 'choisissez une durée'}</span>
                                        </h4>
                                    </legend>
                                    {!hideSliderNbMensualite && (
                                            <div ref={scrollToDureeEpargneSliderRef}>
                                                <CustomSlider
                                                    name="duree"
                                                    options={sliderNbMensualiteOptions}
                                                    value={sliderNbMensualiteOptions.newValue ?? sliderNbMensualiteOptions.defaultValue}
                                                    onChange={handleChangeNbMensualite}
                                                    onSlideEnd={handleFinalizeNbMensualite}
                                                    aria-labelledby="savings-duration-legend"
                                                />
                                            </div>
                                    )}
                                </fieldset>
                                <div className="form-block-info">
                                    {(paiementType === "0" && isStep31aCompleted && dateLivraison) && (
                                    <>
                                        {((sliderDatePrelevementOptions.newValue !== sliderDatePrelevementOptions.min) || (sliderNbMensualiteOptions.newValue !== sliderNbMensualiteOptions.min)) && (
                                        <p className="help">
                                            <b>Astuce réception</b><br/>
                                            Si la date de réception est trop juste pour votre départ en vacances, réduisez la durée de votre épargne et/ou avancez le mois du 1er prélèvement.
                                        </p>
                                        )}
                                        <p className="notice">
                                            <b>Info prélèvement</b><br/>
                                            {(sliderNbMensualiteOptions.newValue === 4) && (
                                                <>
                                                    Si ce premier prélèvement échoue, ou ne peut avoir lieu à la date prévue, le contrat sera automatiquement annulé.
                                                </>
                                            )}
                                            {(sliderNbMensualiteOptions.newValue > 4) && (
                                                <>
                                                    Si le premier prélèvement échoue, ou ne peut avoir lieu à la date prévue, il sera prélevé avec la seconde mensualité. Si deux prélèvements successifs échouent, le contrat sera automatiquement annulé.
                                                </>
                                            )}
                                        </p>
                                        <div className="notice-field">
                                            <div className="notice-field-row">
                                                <p class="field-label">
                                                    <b>Réception</b> au plus tard le<br/>
                                                    (estimation non contractuelle)
                                                </p>
                                                <span className="field-value">{dateLivraison?.locale("fr").format("D MMMM YYYY")}</span>
                                            </div>
                                        </div>
                                    </>
                                    )}
                                </div>
                            </div>


                            {/* Step 3-1b: Epargne */}
                            {isStep31aCompleted && (
                            <>
                                <div className="form-row-separator-30"></div>
                                <div className="form-row" style={{border: isEcartDatePrelev || isEcartQf ? '3px solid #e56d68' : ''}}>
                                    <fieldset className="form-block-wrapper" aria-labelledby="savings-amount-legend">
                                        <div ref={scrollToMontantEpargneRef}>
                                            <legend id="savings-amount-legend">
                                            <h4 className="cgos-h4">
                                                Montant à épargner chaque mois {' '}
                                                <span onClick={() => {
                                                    setHideSliderMontantMensualite(hideSliderMontantMensualite => !hideSliderMontantMensualite);
                                                    setTimeout(() => scrollIfNotVisible(scrollToMontantAchatSliderRef), 100);
                                                }}
                                                      className="slider-value">{montantMensualite ? formatEuro.format(montantMensualite) : 'choisissez un montant'}</span>
                                            </h4>
                                        </legend>
                                        </div>
                                        {!hideSliderMontantMensualite && (
                                                    <div ref={scrollToMontantAchatSliderRef}>
                                                        <CustomSlider
                                                            name="montant1"
                                                            options={sliderMontantMensualiteOptions}
                                                            value={sliderMontantMensualiteOptions.newValue ?? sliderMontantMensualiteOptions.defaultValue}
                                                            onChange={handleChangeMontantMensualite}
                                                            onSlideEnd={handleFinalizeMontantMensualite}
                                                            aria-labelledby="savings-amount-legend"
                                                        />
                                                    </div>
                                        )}
                                    </fieldset>
                                    <div className="form-block-info">
                                        {(paiementType === "0" && isStep31bCompleted && simulRecap) && (
                                        <>
                                            <div className="notice-field">
                                                <div className="notice-field-row">
                                                    <p class="field-label">
                                                        Mon épargne totale sera de
                                                    </p>
                                                    <span className="field-value">{formatEuro.format(simulRecap?.montantParticipationAgent)}</span>
                                                </div>
                                                <div className="notice-field-row">
                                                    <p class="field-label">
                                                        La participation du C.G.O.S (comprise entre {formatEuro.format(participationMinCgos)} et {formatEuro.format(valMaxParticipation)}) sera de
                                                    </p>
                                                    <span className="field-value">{formatEuro.format(simulRecap?.montantParticipationCgos)}</span>
                                                </div>
                                                <div className="notice-field-row">
                                                    <p class="field-label">
                                                        <b>Valeur totale des chèques vacances</b>
                                                    </p>
                                                    <span className="field-value">{formatEuro.format(simulRecap?.montantTotal)}</span>
                                                </div>
                                            </div>

                                            {(simulRecap.montantParticipationCgos < participationMinCgos) && (
                                                <p className="error">
                                                    <b>Adaptez vos choix</b><br/>
                                                    Pour atteindre une participation minimale du C.G.O.S de {formatEuro.format(participationMinCgos)}
                                                </p>
                                            )}

                                            {(simulRecap.montantParticipationCgos >= participationMinCgos) && (simulRecap.montantMaxParticipationCgos && simulRecap.montantParticipationCgos < simulRecap.montantMaxParticipationCgos) && (
                                                <p className="help">
                                                    <b>Astuce participation</b><br/>
                                                    Obtenez une participation plus élevée du C.G.O.S en augmentant le montant à épargner et/ou la durée de votre épargne.
                                                </p>
                                            )}

                                            {(simulRecap.montantMaxParticipationCgos && simulRecap.montantMaxParticipationCgos === simulRecap.montantParticipationCgos) && (
                                                <p className="success">
                                                    <b>Bravo</b>, participation maximale du C.G.O.S atteinte.
                                                </p>
                                            )}
                                        </>
                                        )}
                                    </div>
                                </div>
                            </>
                            )}
                        </>
                        )}

                        <div className="form-row-separator-30"></div>

                        {/* Step 3-2: Montant */}
                        {isStep2Completed && isStep3Completed && paiementType === "1" && (
                            <div className="form-row" style={{border: isEcartDatePrelev || isEcartQf ? '3px solid #e56d68' : ''}}>
                                <fieldset className="form-block-wrapper" aria-labelledby="ancv-amount-legend">
                                    <div ref={scrollToMontantAchatRef}>
                                        <legend id="ancv-amount-legend">
                                        <h4 className="cgos-h4">
                                            Je choisis le montant de mon achat {' '}
                                            <span onClick={() => {
                                                setHideSliderMontantTotal(hideSliderMontantTotal => !hideSliderMontantTotal);
                                                setTimeout(() => scrollIfNotVisible(scrollToMontantEpargneSliderRef), 100);
                                            }}
                                                  className="slider-value">{montantTotal ? montantTotal + ' euros' : 'choisissez un montant'}</span>
                                        </h4>
                                    </legend>
                                    </div>
                                    {!hideSliderMontantTotal && (
                                        <div ref={scrollToMontantEpargneSliderRef}>
                                            <CustomSlider
                                                name="montant2"
                                                options={sliderMontantTotalOptions}
                                                value={sliderMontantTotalOptions.newValue ?? sliderMontantTotalOptions.defaultValue}
                                                onChange={handleChangeMontantTotal}
                                                onSlideEnd={handleFinalizeMontantTotal}
                                                aria-labelledby="ancv-amount-legend"
                                            />
                                        </div>
                                    )}
                                </fieldset>

                                <div className="form-block-info">
                                    {(isStep32Completed && simulRecap) && (
                                        <>
                                            <div className="notice-field">
                                                <div className="notice-field-row">
                                                    <p class="field-label">
                                                        Mon achat sera de
                                                    </p>
                                                    <span className="field-value">{formatEuro.format(simulRecap?.montantParticipationAgent)}</span>
                                                </div>
                                                <div className="notice-field-row">
                                                    <p class="field-label">
                                                        La participation du C.G.O.S (comprise entre {formatEuro.format(participationMinCgos)} et {formatEuro.format(valMaxParticipation)}) sera de
                                                    </p>
                                                    <span className="field-value">{formatEuro.format(simulRecap?.montantParticipationCgos)}</span>
                                                </div>
                                                <div className="notice-field-row">
                                                    <p class="field-label">
                                                        <b>Valeur totale des chèques vacances</b>
                                                    </p>
                                                    <span className="field-value">{formatEuro.format(simulRecap?.montantTotal)}</span>
                                                </div>
                                            </div>

                                            {(simulRecap.montantParticipationCgos < participationMinCgos) && (
                                                <p className="error">
                                                    <b>Adaptez vos choix</b><br/>
                                                    Pour atteindre une participation minimale du C.G.O.S de {formatEuro.format(participationMinCgos)}
                                                </p>
                                            )}

                                            {(simulRecap.montantParticipationCgos >= participationMinCgos) && (simulRecap.montantMaxParticipationCgos && simulRecap.montantParticipationCgos < simulRecap.montantMaxParticipationCgos) && (
                                                <p className="help">
                                                    <b>Astuce participation</b><br/>
                                                    Obtenez une participation plus élevée du C.G.O.S en augmentant le montant de votre achat.
                                                </p>
                                            )}

                                            {(simulRecap.montantMaxParticipationCgos && simulRecap.montantMaxParticipationCgos === simulRecap.montantParticipationCgos) && (
                                                <p className="success">
                                                    <b>Bravo</b>, participation maximale du C.G.O.S atteinte.
                                                </p>
                                            )}
                                        </>
                                    )}

                                </div>
                            </div>
                        )}

                        <div className="form-row-separator-20"></div>

                        {(createMode === mode)  && (
                        <div className="next-button-wrapper">
                            <button type="button"
                                    className="next-button button-arrow"
                                    style={!isSimulateurOk(ancvType, paiementType)
                                        ? {pointerEvents: "none"}
                                        : {}}
                                    disabled={!isSimulateurOk(ancvType, paiementType)}
                                    onClick={(e) => nextStep(e.target, !(hideJustificatif && createMode === mode) ? 2 : 1)}>
                                Etape suivante
                            </button>
                        </div>)}
                        {(editMode === mode && !retourJustificatifPresence)  && (
                            <div className="next-button-wrapper">
                                <button type="button"
                                    className="next-button button-arrow"
                                    style={!isSimulateurOk(ancvType, paiementType)
                                            ? {pointerEvents: "none"}
                                                                : {}}
                                    disabled={!isSimulateurOk(ancvType, paiementType)}
                                    onClick={(e) => nextStep(e.target, !(hideJustificatif && createMode === mode) ? 3 : 1)}>
                                    Etape suivante
                            </button>
                        </div>)}

                    </AccordionTab>

                    {((hideJustificatif && createMode === mode) ||(editMode === mode && retourJustificatifPresence ))  && (
                    <AccordionTab className="cgos-h3" header="3 - J'ajoute mon justificatif de présence" disabled={true}>

                        <div className="form-row">
                            <div className="form-block-wrapper form-block-jus" style={{
                                border: editMode === mode && retourJustificatifPresence ? '3px solid #e56d68' : '',
                                display: editMode === mode && !retourJustificatifPresence ? 'none' : ''
                            }}>


                                <div name="jutificatif_area">
                                    <FieldBuilder code={'NEA_JUSTIFICATIF_ANCV'}
                                                  items={[mimeTypes, justificatifsCategories, 10000000, false, mode === editMode ? editJustificatifMsg : null]}
                                                  onValueChange={(e) => setJustificatifPresence(e)}/>
                                </div>

                            </div>

                            <div className="form-block-info">
                                {(editMode === mode && retourJustificatifPresence )  && <p className="error">
                                  <b>Votre justificatif n’était pas conforme</b><br/>
                                  joindre une copie de votre dernier bulletin de paie ou à défaut une attestation de travail délivrée par votre établissement.
                               </p>}
                            </div>


                        </div>


                        <dl className="dl-horizontal" style={{display: 'initial'}}></dl>

                        <div className="form-row-separator-20"></div>

                        <div className="next-button-wrapper">
                            <button type="button"
                                    className={!((justificatifPresence && justificatifPresence.length > 0) ||retourJustificatifPresence)
                                        ? "next-button button-arrow disabled"
                                        : "next-button button-arrow"}
                                    style={!((justificatifPresence && justificatifPresence.length > 0) || retourJustificatifPresence)
                                        ? {pointerEvents: "none", cursor: "not-allowed"}
                                        : {}}
                                    onClick={(e) => nextStep(e.target, retourJustificatifPresence ? 3 : 1)}
                                    loading={loaderRecap}
                                    disabled={!((justificatifPresence && justificatifPresence.length > 0) || retourJustificatifPresence)}>
                                Etape suivante
                            </button>
                        </div>
                    </AccordionTab>
                    )}

                    <AccordionTab className="cgos-h3" header={(!hideJustificatif ? "3 - " : "4 - ") + "Je vérifie le récapitulatif de ma demande"} disabled={true}>
                        <p>{demandeAncv?.commentaire}</p>

                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="Modalité-de-participation-et-de-livraison">
                                <table>
                                    <thead>
                                    <tr>
                                        <th id="Modalité-de-participation-et-de-livraison" colSpan="2">Modalité de participation et de livraison</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td><b>Format des chèques-vacances</b></td>
                                        {ancvType && (
                                            <td><b>{ancvType ? selectFormatOptions[parseInt(ancvType)].name : ""}</b></td>
                                        )}
                                        {!ancvType && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td><b>Modalité du contrat</b></td>
                                        {paiementType && (
                                            <td><b>{paiementType ? selectParticipationOptions[parseInt(paiementType)].name : ""}</b></td>
                                        )}
                                        {!paiementType && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td>Nombre de mensualité</td>
                                        {simulRecap && (
                                            <td>{paiementType === "0" ? simulRecap?.nombreMensualite : "1"} mois</td>
                                        )}
                                        {!simulRecap && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td>Mon versement mensuel</td>
                                        {simulRecap && (
                                            <td>{paiementType === "0" ? formatEuro.format(simulRecap?.montantMensualite) : formatEuro.format(simulRecap?.montantParticipationAgent)}</td>
                                        )}
                                        {!simulRecap && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        {ancvType === "0" && (
                                        <td>1er prélèvement</td>
                                        )}
                                        {ancvType === "1" && (
                                        <td>1er prélèvement incluant les frais de gestion</td>
                                        )}
                                        {simulRecap && (
                                            <td>{formatEuro.format(calcMontantPremierPrelevement(ancvType))}</td>
                                        )}
                                        {!simulRecap && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td>Date du 1er prélèvement</td>
                                        {datePremierPrelevement && (
                                            <td>{datePremierPrelevement?.locale("fr").format("DD/MM/yyyy")}</td>
                                        )}
                                        {!datePremierPrelevement && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td>Date du dernier prélèvement</td>
                                        {dateDernierPrelevement && (
                                            <td>{dateDernierPrelevement?.locale("fr").format("DD/MM/yyyy")}</td>
                                        )}
                                        {!dateDernierPrelevement && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td>Montant versé en fin de contrat</td>
                                        {simulRecap && (
                                            <td>{formatEuro.format(simulRecap?.montantParticipationAgent)}</td>
                                        )}
                                        {!simulRecap && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td><b>Valeur totale des Chèques-vacances*</b></td>
                                        {simulRecap && (
                                            <td><b>{formatEuro.format(simulRecap?.montantTotal)}</b></td>
                                        )}
                                        {!simulRecap && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td>* Incluant la participation du C.G.O.S</td>
                                        {simulRecap && (
                                            <td>{formatEuro.format(simulRecap?.montantParticipationCgos)}</td>
                                        )}
                                        {!simulRecap && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td><b>Date de réception (non contractuelle)</b></td>
                                        {dateLivraison && (
                                            <td><b>{dateLivraison?.locale("fr").format("DD/MM/yyyy")}</b></td>
                                        )}
                                        {!dateLivraison && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    </tbody>
                                </table>

                            </div>

                            <div className="form-block-info">
                                <p className="help">
                                    <b>Avant d’aller plus loin,</b><br/>
                                    Je vérifie que cette proposition est bien adaptée à mon budget, 
                                    Stopper l’épargne en cours de route, c’est risquer ne pas avoir mes chèques-vacances pour l'activité prévue.

                               </p>

                            </div>

                        </div>

                        <div className="form-row-separator-10"></div>
                        {((hideJustificatif && createMode === mode) ||(editMode === mode && retourJustificatifPresence ))  && (
                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="Mes-documents-justificatifs">
                                <table>
                                    <thead>
                                    <tr>
                                        <th id="Mes-documents-justificatifs" colSpan="2">Mes documents justificatifs</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Justificatif de présence</td>
                                        <td>{justificatifPresence?.length > 0 ? justificatifPresence[0].file.name : ""}</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div className="form-block-info">


                            </div>
                        </div>)}

                        <div className="form-row-separator-20"></div>


                        {isSimulateurOk(ancvType, paiementType) && (!contratFile && !mandatFile) && (
                            <div>
                                <p className="success"><b>Si ce récapitulatif me convient,</b> à l'étape suivante, je vérifie le CONTRAT et le MANDAT</p>
                            </div>
                        )}

                        {!isSimulateurOk(ancvType, paiementType) && (
                            <div>
                                <p className="error"><b>Certaines modalités de votre demande sont manquantes.</b><br/>Vérifiez que vous avez bien répondu à toutes les questions.</p>
                            </div>
                        )}

                        {(!loaderRecap && errorMsgRecap) && (
                        <div>
                            <p className="error" style={{ whiteSpace: "pre-line" }}><b>{errorMsgRetry}</b></p>
                        </div>
                        )}

                        {(!loaderRecap) && (
                            <div className="next-button-wrapper">
                                <button type="button"
                                        className="next-button button-arrow next-button-recap"
                                        style={!isSimulateurOk(ancvType, paiementType) || limitRetryReached 
                                            ? {pointerEvents: "none"}
                                            : {}}
                                        onClick={(e) => {
                                            setLoaderRecap(true);
                                            submitFormDemande(e);
                                        }}
                                        disabled={!isSimulateurOk(ancvType, paiementType) || limitRetryReached}>
                                    Etape suivante
                                </button>
                            </div>
                        )}

                        {loaderRecap && (
                            <div className="loader">
                                <div className="loader-msg">Traitement en cours, merci de patienter</div>
                                <div className="form-row-separator-10"></div>
                                <LoaderDots />
                            </div>
                        )}


                    </AccordionTab>

                    <AccordionTab className="cgos-h3" header={(!hideJustificatif ? "4 - " : "5 - ") + "Je signe et j'envoie ma demande"} disabled={true}>
                        
                        <div className="form-group">
                            {contratFile && mandatFile && (
                                <>
                                    <div>
                                        <p className="success">
                                            Si le CONTRAT et le MANDAT ci-dessous me conviennent,<br/>
                                            <br/>
                                            <b>Tout en bas de l’écran</b>,<br/>
                                            <ul>
                                                <li><b>Je coche</b> la case des <b>mentions légales</b>,</li>
                                                <li>Puis <b>je clique sur le bouton</b> pour <b>signer électroniquement la demande et l’envoyer en même temps</b>.</li>
                                            </ul>
                                            <br/>
                                            <span style={{color: "#932823"}}>Inutile d’imprimer ces documents, après l’envoi de la demande je les retrouverai signés à la rubrique Mes Suivis.</span>
                                        </p>
                                    </div>
                                    <div className="form-row-separator-20" />
                                    <div>
                                        <iframe src={contratFile} width="100%" height="600px" title="Contrat" />
                                    </div>
                                    <div>
                                        <iframe src={mandatFile} width="100%" height="600px" title="Mandat sepa" />
                                    </div>
                                </>
                            )}

                        </div>
                        <div>
                            <br />
                            <br />

                            <div id="textarea-ancv-protection-data" style={{backgroundColor: "#ffffff"}}>
                                <span>{text}</span>
                            </div>
                            <br />
                            <div className="alert alert-warning" style={{display: 'flex', color: "#333031", borderWidth: "0 0 0 5px", borderStyle: "solid", borderColor: "#aa873c", padding: '1rem', fontSize: '14px'}}>
                                <label style={{ display: 'flex', gap: '1.75rem', alignItems: 'flex-start'}}>
                                <input
                                    type="checkbox"
                                    id="check1"
                                    onChange={onPolicyOneChange}
                                     style={{
                                        width: '1rem',
                                        height: '1rem',
                                        cursor: 'pointer',
                                        transform: 'scale(1.5)'
                                    }}
                                />{" "}
                                 <span>
                                    <strong>J’ai lu et j’approuve le CONTRAT</strong> Chèques-vacances ainsi que le <strong>MANDAT DE PRÉLÈVEMENT</strong> SEPA associé. <br /><br />
                                    <strong>J’ai lu et j’approuve la POLITIQUE DE GESTION DES DONNÉES À CARACTÈRES PERSONNEL</strong>.<br /><br />
                                    <strong>Je déclare sur l’honneur L’EXACTITUDE DES INFORMATIONS CONCERNANT MA SITUATION</strong> professionnelle, familiale et financière et je déclare être informé(e) que quiconque se rend coupable de fraude, production de documents falsifiés comme justificatifs, fausses déclarations est passible des peines d’amendes et/ou d’emprisonnement.
                                </span>
                                </label>
                            </div>
                            <br />
                        </div>
                        <div className="form-group">
                        {(!loaderSign && !isSignCompleted) && (
                            <div className="navButtons">
                                <button
                                    className="annuler-dm-btn"
                                    type="button"
                                    name="RETOUR_PRESTATION"
                                    onClick={logoutRemoveData}
                                >
                                    Annuler cette demande
                                </button>&nbsp;&nbsp;&nbsp;

                            {mode == createMode && (
                                <button
                                    className="btn_submit_modal"
                                    type="button"
                                    onClick={(e) => {
                                        setLoaderSign(true);
                                        signAndSendContratMandat(demandeAncv, e);
                                    }}
                                    name="ENVOYER_MA_DEMANDE"

                                    disabled={(!policyOne)}

                                >
                                    JE SIGNE ET J'ENVOIE CETTE DEMANDE
                                </button>
                            )}


                            {mode == editMode && (
                                <button
                                   /* disabled={
                                        disabled ||
                                        !policyOne ||
                                        !policyTwo ||
                                        !usager.numCgos
                                    }*/
                                    className="btn_submit_modal"
                                    type="button"
                                    name="ENVOYER_MA_DEMANDE"
                                    onClick={(e) => {
                                        setLoaderSign(true);
                                        signAndSendContratMandat(demandeAncv, e);
                                    }}
                                >
                                    JE SIGNE ET J'ENVOIE CETTE DEMANDE
                                </button>
                            )}
                            </div>
                        )}
                        </div>

                        {loaderSign && (
                            <div className="loader">
                                <div className="loader-msg">Envoi de la demande en cours, merci de patienter</div>
                                <div className="form-row-separator-10"></div>
                                <LoaderDots />
                            </div>
                        )}

                        <Dialog
                            closable={false}
                            header=""
                            visible={displayBasic}
                            modal
                            footer={basicDialogFooter}
                        >
                            <center>
                                <h2 style={{color: "#333031"}}>
                                   <b> Votre demande et les documents signés ont bien été envoyés au C.G.O.S </b> <br />{" "}
                                </h2>
                                <br />
                                <p style={{color: "#932823"}}>
                                    C’est terminé, vous n’avez rien à faire de plus.
                                </p>
                                 <br />
                                <p style={{color: "#333031"}}>
                                    <b>Cette demande sera étudiée dans les meilleurs délais. </b><br />
                                    Si le C.G.O.S la valide, il signera à son tour le contrat et vous l’enverra via la rubrique Mes suivis.
                                </p>
                                <p style={{color: "#333031"}}>
                                    <b>Suivez l'avancement de votre demande et consultez les documents déjà signés </b>
                                    à la rubrique Mes suivis.
                                </p>
                                <br />
                            </center>
                        </Dialog>

                        <Dialog closable={false} header="" visible={showDemandeError} modal>
                            <center>
                                <h2>
                                    Un problème est survenu lors de l'envoi de votre demande de
                                    prestation : <b>{codeError}</b>
                                    <br/>
                                </h2>
                                <br/>
                                <h3>
                                    Pour renvoyer votre demande allez sur le formulaire de demande{" "}
                                </h3>
                                <br/>
                                <br/>
                                <h3>puis cliquez de nouveau sur le bouton d’envoi.</h3>
                                <br/>
                                <Button
                                    type="button"
                                    label="RÉAFFICHER LE FORMULAIRE"
                                    onClick={() => window.location.reload(false)}
                                    className="btn_submit_modal"
                                />
                            </center>
                        </Dialog>

                        <Dialog
                            closable={false}
                            header=""
                            visible={showFileUploadError}
                            modal
                        >
                            <center>
                                <h2>
                                    Echec d'envoi de votre demande de prestation Chèques culture{" "}
                                    <br/>
                                </h2>
                                <br/>
                                <h3>
                                    En raison d’un problème technique : <b>{codeError}</b> les
                                    documents joints à votre demandes n’ont pas pu être
                                    enregistrés.
                                </h3>
                                <br/>
                                <h3>
                                    Merci de nous renvoyer votre demande après vous être assuré
                                    que les documents joints à celle-ci sont conformes aux
                                    caractéristiques (taille, format) indiquées sur le formulaire.
                                </h3>
                                <br/>
                                <Button
                                    type="button"
                                    label="RÉAFFICHER LE FORMULAIRE"
                                    onClick={() => window.location.reload(false)}
                                    className="btn_submit_modal"
                                />
                            </center>
                        </Dialog>
                    </AccordionTab>
                </Accordion>
            </form>

        </div>

    );
};
